// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-container {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
}

.toggle-container.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.toggle-input {
  display: none;
}

.toggle-slider {
  width: 32px;
  height: 16px;
  background: var(--color-gray);
  border-radius: 20px;
  position: relative;
  transition: background 0.2s ease;
  flex-shrink: 0;
}

.toggle-slider::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 4px;
  width: 8px;
  height: 8px;
  background: var(--text-primary);
  border-radius: 50%;
  transition: transform 0.2s ease, background 0.2s ease;
  box-shadow: var(--shadow-sm);
}

.toggle-slider.active {
  background: var(--accent);
}

.toggle-slider.active::before {
  transform: translateX(16px);
  background: var(--text-on-accent);
}


.toggle-label {
  color: var(--color-black);
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .toggle-slider {
    width: 36px;
    height: 20px;
  }
  
  .toggle-slider::before {
    width: 14px;
    height: 14px;
    left: 3px;
    top: 3px;
  }
  
  .toggle-slider.active::before {
    transform: translateX(16px);
  }
  
  .toggle-label {
    /* Typography component handles font size */
  }
  
  .toggle-container {
    gap: 8px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Toggle/Toggle.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":[".toggle-container {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n  touch-action: manipulation;\n}\n\n.toggle-container.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.toggle-input {\n  display: none;\n}\n\n.toggle-slider {\n  width: 32px;\n  height: 16px;\n  background: var(--color-gray);\n  border-radius: 20px;\n  position: relative;\n  transition: background 0.2s ease;\n  flex-shrink: 0;\n}\n\n.toggle-slider::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 4px;\n  width: 8px;\n  height: 8px;\n  background: var(--text-primary);\n  border-radius: 50%;\n  transition: transform 0.2s ease, background 0.2s ease;\n  box-shadow: var(--shadow-sm);\n}\n\n.toggle-slider.active {\n  background: var(--accent);\n}\n\n.toggle-slider.active::before {\n  transform: translateX(16px);\n  background: var(--text-on-accent);\n}\n\n\n.toggle-label {\n  color: var(--color-black);\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .toggle-slider {\n    width: 36px;\n    height: 20px;\n  }\n  \n  .toggle-slider::before {\n    width: 14px;\n    height: 14px;\n    left: 3px;\n    top: 3px;\n  }\n  \n  .toggle-slider.active::before {\n    transform: translateX(16px);\n  }\n  \n  .toggle-label {\n    /* Typography component handles font size */\n  }\n  \n  .toggle-container {\n    gap: 8px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
